var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8003 73.0989C25.8003 80.2236 20.0247 85.9992 12.9008 85.9992C5.7761 85.9992 0.000488281 80.2236 0.000488281 73.0989C0.000488281 65.975 5.7761 60.1993 12.9008 60.1993C20.0247 60.1993 25.8003 65.975 25.8003 73.0989Z",
    fill: "#3134DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0438 41.7508C28.0438 41.7508 24.7533 47.3991 22.7936 52.3013C20.8339 57.2044 19.3244 63.5646 19.3244 63.5646L13.0874 61.0737C13.0874 61.0737 16.3669 55.4538 18.3376 50.5238C20.3076 45.5938 21.8067 39.2605 21.8067 39.2605L28.0438 41.7508Z",
    fill: "#3134DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2612 23.7586C39.2612 23.7586 45.6145 22.2156 50.5071 20.2367C55.3983 18.2578 61.0256 14.9564 61.0256 14.9564L63.5653 21.1106C63.5653 21.1106 57.2398 22.644 52.3195 24.6325C47.4014 26.6232 41.7996 29.9128 41.7996 29.9128L39.2612 23.7586Z",
    fill: "#3134DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86 12.9003C86 20.0242 80.2244 25.7998 73.0997 25.7998C65.9758 25.7998 60.2002 20.0242 60.2002 12.9003C60.2002 5.77561 65.9758 0 73.0997 0C80.2244 0 86 5.77561 86 12.9003Z",
    fill: "#8665CB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0003 29.9124C43.0003 37.14 37.1413 42.9996 29.9135 42.9996C22.6857 42.9996 16.8267 37.14 16.8267 29.9124C16.8267 22.6854 22.6857 16.8259 29.9135 16.8259C37.1413 16.8259 43.0003 22.6855 43.0003 29.9124Z",
    fill: "#009EE1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.fdfe8cec9bef297cec5caef1391896dc.svg";
export { ForwardRef as ReactComponent };